// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 240px;
    background-color: #D9CFC4; /* warmer beige tone */
    padding: 12px 0;
    height: 100vh;
    overflow-y: auto;
    font-family: 'Poppins', sans-serif;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.06);
}

.sidebar-group {
    margin: 2px 0;
}

.sidebar-title {
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    margin: 4px 8px;
    border-radius: 6px;
    transition: background-color 0.3s ease;
    cursor: pointer;
}

    .sidebar-title:hover {
        background-color: #FFF;
    }

    .sidebar-title span:first-child {
        display: flex;
        align-items: center;
        margin-right: 8px;
    }

    .sidebar-title span:nth-child(2) {
        flex: 1 1;
        font-size: 14px;
    }

.sidebar-items {
    padding: 2px 0 6px 26px;
}

.sidebar-link {
    display: block;
    padding: 6px 10px;
    font-size: 13px;
    color: #222;
    text-decoration: none;
    border-radius: 4px;
    transition: background 0.2s;
}

    .sidebar-link:hover {
        background-color: #f1ede8;
    }

    .sidebar-link.active {
        background-color: #ccc1b5;
        font-weight: bold;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/common/SidebarMenu.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB,EAAE,sBAAsB;IACjD,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kCAAkC;IAClC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;AACnB;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,SAAO;QACP,eAAe;IACnB;;AAEJ;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;AAC/B;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB","sourcesContent":[".sidebar {\n    width: 240px;\n    background-color: #D9CFC4; /* warmer beige tone */\n    padding: 12px 0;\n    height: 100vh;\n    overflow-y: auto;\n    font-family: 'Poppins', sans-serif;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.06);\n}\n\n.sidebar-group {\n    margin: 2px 0;\n}\n\n.sidebar-title {\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 16px;\n    margin: 4px 8px;\n    border-radius: 6px;\n    transition: background-color 0.3s ease;\n    cursor: pointer;\n}\n\n    .sidebar-title:hover {\n        background-color: #FFF;\n    }\n\n    .sidebar-title span:first-child {\n        display: flex;\n        align-items: center;\n        margin-right: 8px;\n    }\n\n    .sidebar-title span:nth-child(2) {\n        flex: 1;\n        font-size: 14px;\n    }\n\n.sidebar-items {\n    padding: 2px 0 6px 26px;\n}\n\n.sidebar-link {\n    display: block;\n    padding: 6px 10px;\n    font-size: 13px;\n    color: #222;\n    text-decoration: none;\n    border-radius: 4px;\n    transition: background 0.2s;\n}\n\n    .sidebar-link:hover {\n        background-color: #f1ede8;\n    }\n\n    .sidebar-link.active {\n        background-color: #ccc1b5;\n        font-weight: bold;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
